












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '@/types/frontend'
import EditFollowers from '@/components/TestDetails/EditFollowers.vue'
import FollowerData from '@/views/TestDetails.vue'
import ClickOutside from 'v-click-outside'
import Bubble from '../Bubble.vue'
import EditBubble from './EditBubble.vue'
import HoverBox from './HoverBox.vue'

@Component({
  components: {
    EditFollowers,
    Bubble,
    EditBubble,
    HoverBox
  },
  directives: { clickOutside: ClickOutside.directive }
})
export default class Followers extends Vue {
  @Prop({ required: true }) readonly followers!: User[]
  @Prop({ required: true }) readonly users!: User[]

  showCount = 9
  showList = false
  showMore = false

  editFollower (data: FollowerData) {
    this.$emit('editFollower', data)
  }

  toggle () {
    this.showList = !this.showList
  }

  close () {
    this.showList = false
  }
}
